const SEARCH_TAB = {
  all: 'all',
  product: 'product',
  plus_shop: 'plus_shop',
  creator: 'creator',
  popup_store: 'popup_store',
  curation: 'curation',
} as const;

type SearchTabType = keyof typeof SEARCH_TAB;

type SearchTabMap = {
  [K in SearchTabType]: {
    url: string;
    label: string;
    key: (typeof SEARCH_TAB)[K];
    query?: string;
  };
};

export const SEARCH_TAB_MAP: SearchTabMap = {
  [SEARCH_TAB.all]: {
    url: '/@/search',
    get label() {
      return ET('mps2::search::all');
    },
    key: SEARCH_TAB.all,
  },
  [SEARCH_TAB.product]: {
    url: `/@/search?tab=${SEARCH_TAB.product}`,
    get label() {
      return ET('mps2::search::product');
    },
    key: SEARCH_TAB.product,
    query: SEARCH_TAB.product,
  },
  [SEARCH_TAB.plus_shop]: {
    url: `/@/search?tab=${SEARCH_TAB.plus_shop}`,
    get label() {
      return ET('mps2::search::plus_shop');
    },
    key: SEARCH_TAB.plus_shop,
    query: SEARCH_TAB.plus_shop,
  },
  [SEARCH_TAB.creator]: {
    url: `/@/search?tab=${SEARCH_TAB.creator}`,
    get label() {
      return ET('mps2::search::creator');
    },
    key: SEARCH_TAB.creator,
    query: SEARCH_TAB.creator,
  },
  [SEARCH_TAB.popup_store]: {
    url: `/@/search?tab=${SEARCH_TAB.popup_store}`,
    get label() {
      return ET('mps2::search::popup_store');
    },
    key: SEARCH_TAB.popup_store,
    query: SEARCH_TAB.popup_store,
  },
  [SEARCH_TAB.curation]: {
    url: `/@/search?tab=${SEARCH_TAB.curation}`,
    get label() {
      return ET('mps2::search::curation');
    },
    key: SEARCH_TAB.curation,
    query: SEARCH_TAB.curation,
  },
} as const;

const SEARCH_RESULT_LIMIT: Record<
  | typeof SEARCH_TAB.product
  | typeof SEARCH_TAB.creator
  | typeof SEARCH_TAB.popup_store
  | typeof SEARCH_TAB.curation,
  { PC: number; MOBILE: number }
> = {
  [SEARCH_TAB.product]: { PC: 120, MOBILE: 60 },
  // 플러스샵 추가 필요
  [SEARCH_TAB.creator]: { PC: 120, MOBILE: 30 },
  [SEARCH_TAB.popup_store]: { PC: 60, MOBILE: 20 },
  [SEARCH_TAB.curation]: { PC: 40, MOBILE: 20 },
} as const;

export const getSearchResultLimit = (tab: keyof typeof SEARCH_RESULT_LIMIT, is_mobile: boolean) => {
  return is_mobile ? SEARCH_RESULT_LIMIT[tab].MOBILE : SEARCH_RESULT_LIMIT[tab].PC;
};
